// src/components/home/WelcomePopup.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaCheck, FaProductHunt, FaRocket, FaTimes, FaSparkles } from "react-icons/fa";
import "./WelcomePopup.css";

const WelcomePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const isSeen = localStorage.getItem("bodhai_welcome_seen");
    if (isSeen !== "true") {
      setIsVisible(true);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem("bodhai_welcome_seen", "true");
  };

  if (!isVisible) return null;

  return (
    <div className="bvh-welcome-popup-overlay">
      <div className="bvh-welcome-popup-card">
        {/* Top Close Button */}
        <button
          className="bvh-welcome-close-corner"
          onClick={handleClose}
          title="Close modal"
        >
          <FaTimes />
        </button>

        {/* Icon Header */}
        <div className="bvh-welcome-popup-icon">
          🎉
        </div>

        <h2 className="bvh-welcome-popup-title">Welcome to BodhAI</h2>
        <p className="bvh-welcome-popup-subtitle">
          BodhAI V2 Beta is now LIVE! We are also featured on Product Hunt today.
        </p>

        {/* 2x2 Feature Check Grid */}
        <div className="bvh-welcome-popup-features">
          <div className="bvh-welcome-feature-item">
            <span className="bvh-welcome-feature-icon"><FaCheck /></span> Better Dashboard
          </div>
          <div className="bvh-welcome-feature-item">
            <span className="bvh-welcome-feature-icon"><FaCheck /></span> Faster Performance
          </div>
          <div className="bvh-welcome-feature-item">
            <span className="bvh-welcome-feature-icon"><FaCheck /></span> Smarter AI Engine
          </div>
          <div className="bvh-welcome-feature-item">
            <span className="bvh-welcome-feature-icon"><FaCheck /></span> Product Hunt Launch
          </div>
        </div>

        {/* Action Buttons */}
        <div className="bvh-welcome-popup-actions">
          <a
            href="https://betav2.bodhai.pages.dev/"
            target="_blank"
            rel="noopener noreferrer"
            className="bvh-welcome-btn primary"
            onClick={handleClose}
          >
            <FaRocket /> Explore Beta
          </a>

          <a
            href="https://www.producthunt.com/products/bodhai?utm_source=bodhai.pages.dev&utm_medium=referral&utm_campaign=bodhai_product_launch_july_2026&utm_content=visit_producthunt_from_bodhai_homepage&utm_term=ai_learning_tool_launch"
            target="_blank"
            rel="noopener noreferrer"
            className="bvh-welcome-btn ph"
            onClick={handleClose}
          >
            <FaProductHunt /> Support Us
          </a>

          <button className="bvh-welcome-btn later" onClick={handleClose}>
            Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default React.memo(WelcomePopup);
